export default "__VITE_ASSET__D1$xB$B6__"